import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CallWaiterService } from '@core';
import { CallWaiterIndicatorComponent } from '@app/components/call-waiter-indicator/call-waiter-indicator.component';

@Component({
  selector: 'app-call-waiter-main-button',
  standalone: true,
  imports: [
    TranslateModule,
    CallWaiterIndicatorComponent,
  ],
  templateUrl: './call-waiter-main-button.component.html',
  styleUrls: ['./call-waiter-main-button.component.scss'],
  host: {
    'role': 'button',
    '[class.disabled]': 'disabled()',
    '[class.active]': 'callWaiterMain()',
    '(click)': 'onClick($event)',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallWaiterMainButtonComponent {

  public readonly callWaiterMain = toSignal(this.callWaiterService.mainStatus$, {
    initialValue: true,
  });

  public readonly callWaiterRequestBill = toSignal(this.callWaiterService.requestBillStatus$, {
    requireSync: true,
  });

  public readonly callWaiterAnotherRound = toSignal(this.callWaiterService.anotherRoundStatus$, {
    requireSync: true,
  });

  public readonly disabled = computed(() => {
    return this.callWaiterRequestBill() || this.callWaiterAnotherRound();
  });

  constructor(
    private readonly callWaiterService: CallWaiterService,
  ) {}

  public onClick($event: MouseEvent): void {
    if ($event.target instanceof HTMLElement) {
      $event.preventDefault();

      if (this.disabled()) {
        return;
      }

      this.callWaiterService.setMain(!this.callWaiterMain());
    }
  }

}
